import React from 'react'
import { useAppDispatch } from 'reduxTyped'
import { l, List, MainNavigation } from '@manychat/manyui'
import { AccountOption } from '@manychat/manyui/src/components/MainNavigation/AccountSelect/interfaces'

import { makeAccountFavorite } from 'apps/profile/actions/profileActions'
import { Account } from 'apps/profile/models/Page/helpers'
import { RegistrationSection } from 'apps/registration/interfaces/registration'
import { NavigationRoute, newNav } from 'common/core/router'
import { getProfileImageStubURL } from 'utils/assets'
import { typedRouting } from 'utils/router/typedRouting'
import { analyticsService } from 'utils/services/analytics'

import { BottomContent } from './BottomContent'
import { NavItem } from './NavItem'
import { useNavParams } from './useNavParams'
import { getAccountStatusLozenge } from './utils'

interface NewSidebarProps {
  isSidebarHidden: boolean
  accID: string
  accounts: Account[]
  onToggleSidebar: () => void
}

export const NewSidebar = ({
  isSidebarHidden,
  accID,
  accounts,
  onToggleSidebar,
}: NewSidebarProps) => {
  const dispatch = useAppDispatch()

  const { isMobileWidth } = useNavParams()

  const handleItemClick = (item: NavigationRoute) => {
    if (item.url === '/dashboard') {
      analyticsService.sendEvent(`SIDEBAR.HOME_TAB.CLICKED`)
    }
    if (isMobileWidth) {
      onToggleSidebar()
    }
  }

  const handlePinToggle = (account: AccountOption, isFavorite: boolean) => {
    dispatch(makeAccountFavorite({ accountId: String(account.value), isFavorite }))
  }

  const handleAccountAddClick = () => {
    const connectionLink = typedRouting.linkBuilder.registration({
      section: RegistrationSection.CHANNEL_CONNECTION,
    })
    window.location.href = connectionLink
  }

  const handleAccountChange = (account: AccountOption) => {
    const id = account.value
    location.assign(`/fb${id}/dashboard`)
  }

  const accountOptions = accounts.map<AccountOption>((account) => ({
    label: account.name,
    value: account.id,
    lozenge: getAccountStatusLozenge(account.accountStatus),
    avatarUrl: account.avatar || getProfileImageStubURL(),
    isPinned: account.isFavorite,
  }))

  const selectedAccount = accountOptions.find((acc) => accID.includes(String(acc.value))) || null

  return (
    <MainNavigation
      ariaLabel={l.translate('Main navigation')}
      skipToContentTarget="#appContent"
      skipToContentLabel={l.translate('Skip to main content')}
      data-test-id="sidebar"
      expanded={!isSidebarHidden}
      accounts={accountOptions}
      selectedAccount={selectedAccount}
      onAccountChange={handleAccountChange}
      onAccountPinToggle={handlePinToggle}
      onAccountAddClick={handleAccountAddClick}
      menuContent={
        <List className="p-a-0 d-flex flex-col">
          {newNav.map((item, index: number) => (
            <NavItem
              key={index}
              item={item}
              index={index}
              expanded={!isSidebarHidden}
              onClick={() => handleItemClick(item)}
            />
          ))}
        </List>
      }
      bottomContent={<BottomContent />}
      onClick={onToggleSidebar}
    />
  )
}
